import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { baseExtraReducers, baseGetData, baseInitialState, baseReducers } from 'helpers/slice.helper';
import { APP_URLS } from 'constants/url.constant';

const name = 'companyDetailStaff';

export const getData = createAsyncThunk(
    `${name}/getData`,
    async props =>
        await baseGetData({ url: APP_URLS.ADMIN_COMPANIES_DETAIL_STAFFS.replace(':id', props['id']), ...props })
);

export const defaultFilters = {};

const companyDetailStaffSlice = createSlice({
    name,
    initialState: {
        ...baseInitialState,
        filters: defaultFilters,
        sorter: {
            field: 'created_at',
            order: 'ascend',
        },
    },
    reducers: baseReducers,
    extraReducers: baseExtraReducers(getData),
});

export const { setLoading, setData, setPagination, setFilters, setSorter, setHideColumns, setSelection } =
    companyDetailStaffSlice.actions;

export default companyDetailStaffSlice.reducer;
